import { render, staticRenderFns } from "./sizhi.vue?vue&type=template&id=e1a87eea&scoped=true&"
import script from "./sizhi.vue?vue&type=script&lang=js&"
export * from "./sizhi.vue?vue&type=script&lang=js&"
import style0 from "./sizhi.vue?vue&type=style&index=0&id=e1a87eea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a87eea",
  null
  
)

export default component.exports